export default "__VITE_ASSET__6825aaa6__"